import React from 'react'
import styled from 'styled-components'
import Box from '@ui/Box'
import { Modal } from 'antd'
import { requestHelp, useGetProfile } from '@api/users'
import IconButton from '@ui/IconButton'
import { useNotification } from '@ui/NotificationProvider'
import { withHandledErrors } from '@utils/errors'
import { sendAnalyticsEvent } from '@utils/analytics'
import HelpButton from '@components/HelpButton/HelpButton'
import routes from '@routes'
import { Color } from '@interfaces/designSystem'

type Props = {
  open: boolean
  onClose: () => void
}

const Video = styled.video`
  max-width: 1200px;
  width: 100%;
  height: auto;
  margin-top: 16px;
  border-radius: 30px;
`

const Link = styled.a`
  color: ${Color.Blue_70};
  text-decoration: underline;
`

const HelpPopup = ({ onClose, open }: Props) => {
  // otherwise video is still playing
  if (!open) {
    return null
  }

  return (
    <Modal title="We are here to help" open onCancel={onClose} footer={null} width={900}>
      Please check out our{' '}
      <Link href={routes.publicRoutes.fullTutorial} target="_blank">
        Help Centre
      </Link>{' '}
      for more information on how to use the product.
      <Box>Also you could check out the video:</Box>
      <Video
        loop
        autoPlay={false}
        controls
        muted
        poster="https://enhanci-widgets.s3.eu-west-2.amazonaws.com/static/enhanci_promo_poster.png"
      >
        <source
          src="https://enhanci-widgets.s3.eu-west-2.amazonaws.com/static/enhanci_promo.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </Video>
      <HelpButton />
    </Modal>
  )
}

export default HelpPopup
